{
  "clear": "Golire",
  "invalid": "(nevalid)",
  "loading": "Se încarcă...",
  "noResults": "Niciun rezultat"
}
